<template>
  <div>
    <div class="trig-builder">
      <div class="trig-timing">
        <div class="trig-when-opts">
          <label class="trig-when-opt" :class="{on: value.type === 'immediate'}" @click="set('type', 'immediate')">
            <input type="radio" name="trig_when" value="immediate" :checked="value.type === 'immediate'" />
            <div style="flex:1;min-width:0">
              <div class="trig-when-label">⚡ Ngay lập tức</div>
              <div class="trig-when-desc">AI chạy ngay lập tức khi bấm Chạy phân tích</div>
            </div>
          </label>

          <label class="trig-when-opt" :class="{on: value.type === 'delay'}" @click="set('type', 'delay')">
            <input type="radio" name="trig_when" value="delay" :checked="value.type === 'delay'" />
            <div style="flex:1;min-width:0">
              <div class="trig-when-label">⏱ Sau một khoảng thời gian</div>
              <div class="trig-when-desc">{{ delayPreview }}</div>
            </div>
          </label>
          <div class="trig-sub" :class="{show: value.type === 'delay'}">
            <div class="trig-sub-row">
              <span class="trig-sub-lbl">Sau</span>
              <el-input-number
                :value="value.delayVal"
                size="mini"
                :min="1"
                :max="999"
                controls-position="right"
                style="width:110px;flex-shrink:0"
                @change="set('delayVal', $event)" />
              <el-select :value="value.delayUnit" size="mini" style="flex:1" @change="set('delayUnit', $event)">
                <el-option label="Giờ" value="giờ" />
                <el-option label="Ngày" value="ngày" />
              </el-select>
            </div>
          </div>

          <label class="trig-when-opt" :class="{on: value.type === 'daily'}" @click="set('type', 'daily')">
            <input type="radio" name="trig_when" value="daily" :checked="value.type === 'daily'" />
            <div style="flex:1;min-width:0">
              <div class="trig-when-label">🌅 Mỗi ngày</div>
              <div class="trig-when-desc">{{ dailyPreview }}</div>
            </div>
          </label>
          <div class="trig-sub" :class="{show: value.type === 'daily'}">
            <div class="trig-sub-row">
              <span class="trig-sub-lbl">Vào lúc</span>
              <el-time-select
                v-model="dailyTime"
                size="mini"
                :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                placeholder="Chọn giờ"
                style="flex:1" />
            </div>
          </div>

          <label class="trig-when-opt" :class="{on: value.type === 'weekly'}" @click="set('type', 'weekly')">
            <input type="radio" name="trig_when" value="weekly" :checked="value.type === 'weekly'" />
            <div style="flex:1;min-width:0">
              <div class="trig-when-label">📅 Mỗi tuần</div>
              <div class="trig-when-desc">{{ weeklyPreview }}</div>
            </div>
          </label>
          <div class="trig-sub" :class="{show: value.type === 'weekly'}">
            <div class="trig-sub-row">
              <span class="trig-sub-lbl">Vào ngày</span>
              <el-select :value="value.weeklyDay" size="mini" style="flex:1.4" @change="set('weeklyDay', $event)">
                <el-option v-for="(label, code) in DAY_MAP" :key="code" :label="label" :value="code" />
              </el-select>
              <el-time-select
                v-model="weeklyTime"
                size="mini"
                :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                placeholder="Chọn giờ"
                style="flex:1" />
            </div>
          </div>

          <label class="trig-when-opt" :class="{on: value.type === 'monthly'}" @click="set('type', 'monthly')">
            <input type="radio" name="trig_when" value="monthly" :checked="value.type === 'monthly'" />
            <div style="flex:1;min-width:0">
              <div class="trig-when-label">🗓 Mỗi tháng</div>
              <div class="trig-when-desc">{{ monthlyPreview }}</div>
            </div>
          </label>
          <div class="trig-sub" :class="{show: value.type === 'monthly'}">
            <div class="trig-sub-row">
              <span class="trig-sub-lbl">Vào ngày</span>
              <el-input-number
                :value="value.monthlyDay"
                size="mini"
                :min="1"
                :max="monthlyMax"
                controls-position="right"
                style="width:110px;flex-shrink:0"
                @change="set('monthlyDay', clampDay($event))" />
              <span style="font-size:12px;color:var(--t3);white-space:nowrap">hàng tháng</span>
              <el-time-select
                v-model="monthlyTime"
                size="mini"
                :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                placeholder="Chọn giờ"
                style="flex:1" />
            </div>
            <div class="trig-month-warn" v-if="monthEdgeWarn">
              <i class="el-icon-warning-outline"></i>
              Nếu tháng không có ngày này, sẽ chạy vào ngày cuối tháng
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="trig-readable" style="margin-top:10px">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
      <div class="trig-readable-txt" v-html="readableSummary"></div>
    </div>
  </div>
</template>

<script>
const DAY_MAP = { mon: 'Thứ Hai', tue: 'Thứ Ba', wed: 'Thứ Tư', thu: 'Thứ Năm', fri: 'Thứ Sáu', sat: 'Thứ Bảy', sun: 'Chủ nhật' };

export default {
  name: 'SaleAITriggerSection',
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return { DAY_MAP };
  },
  computed: {
    // v-model proxies for el-time-select: :value + @change doesn't reliably
    // round-trip in Element UI 2.x for el-time-select; v-model on a computed
    // get/set pair does, and stays one-way to the parent via set().
    dailyTime: {
      get() { return this.value.dailyTime; },
      set(v) { this.set('dailyTime', v); },
    },
    weeklyTime: {
      get() { return this.value.weeklyTime; },
      set(v) { this.set('weeklyTime', v); },
    },
    monthlyTime: {
      get() { return this.value.monthlyTime; },
      set(v) { this.set('monthlyTime', v); },
    },
    delayPreview() {
      return 'AI chạy sau khi bấm Chạy phân tích ' + this.value.delayVal + ' ' + this.value.delayUnit;
    },
    dailyPreview() {
      return 'AI chạy hàng ngày lúc ' + this.value.dailyTime + ' trên tập hội thoại theo bộ lọc đã lưu';
    },
    weeklyPreview() {
      return 'AI chạy vào ' + (DAY_MAP[this.value.weeklyDay] || 'Thứ Hai') + ' lúc ' + this.value.weeklyTime + ' hàng tuần';
    },
    monthlyPreview() {
      return 'AI chạy ngày ' + (this.value.monthlyDay || '1') + ' hàng tháng lúc ' + this.value.monthlyTime;
    },
    monthEdgeWarn() {
      const d = this.value.monthlyDay;
      return d > 28 && d <= 31;
    },
    // Max day for "Mỗi tháng" picker = số ngày của tháng hiện tại
    monthlyMax() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    },
    readableSummary() {
      const v = this.value;
      let t = '';
      if (v.type === 'immediate') t = '<strong>ngay lập tức</strong>';
      else if (v.type === 'delay') t = 'sau <strong>' + v.delayVal + ' ' + v.delayUnit + '</strong>';
      else if (v.type === 'daily') t = '<strong>hàng ngày lúc ' + v.dailyTime + '</strong>';
      else if (v.type === 'weekly') t = '<strong>mỗi ' + (DAY_MAP[v.weeklyDay] || 'Thứ Hai') + ' lúc ' + v.weeklyTime + ' hàng tuần</strong>';
      else if (v.type === 'monthly') t = '<strong>vào ngày ' + (v.monthlyDay || 1) + ' hàng tháng lúc ' + v.monthlyTime + '</strong>';
      return 'AI sẽ tự động chạy ' + t + ' khi bấm Chạy phân tích.';
    },
  },
  mounted() {
    if (this.value && this.value.monthlyDay > this.monthlyMax) {
      this.set('monthlyDay', this.monthlyMax);
    }
  },
  watch: {
    // Khi load config có monthlyDay vượt số ngày tháng hiện tại → clamp xuống.
    'value.monthlyDay'(v) {
      if (v > this.monthlyMax) this.set('monthlyDay', this.monthlyMax);
    },
  },
  methods: {
    set(key, val) {
      this.$emit('input', { ...this.value, [key]: val });
    },
    clampDay(v) {
      const n = parseInt(v, 10);
      if (!Number.isFinite(n)) return 1;
      return Math.min(this.monthlyMax, Math.max(1, n));
    },
  },
};
</script>
